<div [class.open]="select_open" class="select_list">
    <div #select_header (click)="select_open = !select_open" class="header">
        <span [innerHTML]="selected.length ? selectedRow() : 'MAIN_MENU.NOT_SELECTED' | translate"></span>
        <i class="icon-down"></i>
    </div>
    <div #select_body *ngIf="select_open" [@fade]="'in'" class="list">
        <div style="padding: 5px 10px;">
            <input [formControl]="query" placeholder="Поиск" type="text">
        </div>
        <ng-container *ngFor="let item of row; let i = index">
            <label (click)="selectItems(item)" [class.selected]="item.selected">
                <span>{{ item.name }}</span>
            </label>
        </ng-container>
        <ng-container *ngIf="!row || !row.length">
            <label>
                <span>
                    <b>Результатов нет</b>
                </span>
            </label>
        </ng-container>
    </div>
</div>
